<template>
  <div :class="$style.wrap">
    <div :class="$style.loader_simple"/>
    <div :class="$style.progress_container" v-if="steps">
      <div :class="$style.progress_bar" :style="{width: `${currentProgress}%`}"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'modalLoadingBallScaleRippleMultiple',
  computed: {
    ...mapState('modal', ['loadings']),
    steps() {
      return this.loadings.data?.allSteps || 0;
    },
  },
  data() {
    return {
      currentProgress: 0,
    };
  },
  watch: {
    'loadings.data': {
      handler() {
        if (this.loadings.data?.allSteps && this.loadings.data?.now) {
          this.updateStep();
        }
      },
      deep: true,
      immediate: true, // 初回はDOM生成後に確認
    },
  },
  methods: {
    updateStep() {
      const totalSteps = this.loadings.data.allSteps;
      const nowStep = this.loadings.data.now;

      this.currentProgress = (nowStep / totalSteps) * 100;
    },
  },
};
</script>

<style lang="scss" module>
@import '@/assets/scss/_mq.scss';

.wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0; bottom: 0;
  left: 0; right: 0;
  z-index: 10;
  height: calc(100vh - var(--header-height));
}
.loader_simple {
  width: 3.5em;
  height: 3.5em;
  animation: rotation 1s infinite linear;
  border: 4px solid rgba(black, .1);
  border-top-color: var(--orange-main);
  border-radius: 50%;
  position: absolute;
  top: 0; bottom: 0;
  left: 0; right: 0;
  margin: auto;
  z-index: 3;
}
@keyframes rotation {
  to {
    transform: rotate(360deg);
  }
}

.progress_container {
  position: relative;
  background-color: rgba(black, .2);
  z-index: 100;
  @include smView {
    margin-top: 140px;
    width: 40%;
  }
  @include lgViewOnly {
    margin-top: 170px;
    width: 25%;
  }
}
.progress_bar {
  width: 0%;
  height: 8px;
  background-color: rgba(black, .4);
  transition: width 0.4s ease;
}
</style>
